/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  DeleteApiEmployeesIdMutationResponse,
  DeleteApiEmployeesIdPathParams,
} from '../models/DeleteApiEmployeesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { deleteApiEmployeesIdMutationResponseSchema } from '../zod/deleteApiEmployeesIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const deleteApiEmployeesIdMutationKey = () =>
  [{ url: '/api/employees/:id' }] as const;

export type DeleteApiEmployeesIdMutationKey = ReturnType<
  typeof deleteApiEmployeesIdMutationKey
>;

/**
 * {@link /api/employees/:id}
 */
export async function deleteApiEmployeesId(
  id: DeleteApiEmployeesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiEmployeesIdMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'DELETE',
    url: `/api/employees/${id}`,
    ...requestConfig,
  });
  return deleteApiEmployeesIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/employees/:id}
 */
export function useDeleteApiEmployeesId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteApiEmployeesIdMutationResponse,
      ResponseErrorConfig<Error>,
      { id: DeleteApiEmployeesIdPathParams['id'] },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteApiEmployeesIdMutationKey();

  return useMutation<
    DeleteApiEmployeesIdMutationResponse,
    ResponseErrorConfig<Error>,
    { id: DeleteApiEmployeesIdPathParams['id'] },
    TContext
  >(
    {
      mutationFn: async ({ id }) => {
        return deleteApiEmployeesId(id, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
